export default __webpack_public_path__ + "static/media/b50.665df60c.png";